import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { UPLOAD_IMAGE, UPLOAD_IMAGE_FAIL, UPLOAD_IMAGE_SUCCESS, UploadImageAction } from '../redux/manageSlidesReducer'

interface Response {
  image_url: string
}

function* UploadSlideImageFlow(action: UploadImageAction): Generator<any, void, any> {
  try {
    const response: Response = yield call(apiCall, {
      endpoint: '/tutors/lesson_plans/upload_image',
      method: 'POST',
      params: { image: action.payload.base64Image }
    })
    yield put(UPLOAD_IMAGE_SUCCESS({ imageUrl: response.image_url }))
  } catch (error) {
    yield put(UPLOAD_IMAGE_FAIL())
    console.log(error)
  }
}

export default function* UploadSlideImageSaga(): Generator<any, void, any> {
  yield takeLatest([UPLOAD_IMAGE], UploadSlideImageFlow)
}
